"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertCents = assertCents;
exports.applyPercent = applyPercent;
exports.htFromTtc = htFromTtc;
exports.vatFromTtc = vatFromTtc;
const errors_1 = require("../errors");
function assertCents(value, label) {
    if (!Number.isInteger(value)) {
        throw new errors_1.InvalidAmountError(`${label} doit être un montant entier en centimes, reçu : ${value}`);
    }
}
// Demi-haut : un demi-centime arrondit toujours vers le haut (Math.round).
// Non défini pour les montants négatifs — annulations/avoirs hors chantier.
function roundHalfUp(value) {
    if (value < 0) {
        throw new errors_1.InvalidAmountError('roundHalfUp : montant négatif non supporté (annulations/avoirs hors chantier)');
    }
    return Math.round(value);
}
function applyPercent(amount, percent) {
    assertCents(amount, 'applyPercent.amount');
    if (!Number.isFinite(percent)) {
        throw new errors_1.InvalidPercentError(`applyPercent.percent doit être un nombre fini, reçu : ${percent}`);
    }
    // Points de base entiers : évite de perdre le demi-centime sur un
    // pourcentage à deux décimales par accumulation d'erreurs flottantes.
    const basisPoints = Math.round(percent * 100);
    if (Math.abs(percent * 100 - basisPoints) > 1e-6) {
        throw new errors_1.InvalidPercentError(`applyPercent.percent doit avoir au plus deux décimales, reçu : ${percent}`);
    }
    return roundHalfUp((amount * basisPoints) / 10000);
}
function htFromTtc(ttc, ratePercent) {
    assertCents(ttc, 'htFromTtc.ttc');
    return roundHalfUp(ttc / (1 + ratePercent / 100));
}
function vatFromTtc(ttc, ratePercent) {
    return ttc - htFromTtc(ttc, ratePercent);
}
